import { type ItemTypeBase, ItemWrapperTypeBase, SectionWrapperTypeBase } from "../js/enums.ts";

export enum ItemTypeCustom {
	CONTACT = 'contact',
	MAP = 'map',
	MAP_DELIVERY = 'mapDelivery',
	LATEST = 'news',
	NEWS = 'singleNews',
	SERVICE = 'service',
	PAGEBOX = 'pageBox',
	SURVEY = 'survey',
	NEWSLETTER = 'newsletter',
	MENUITEM = 'menuItem',
	DOWNLOADS = 'downloads',
	CV = 'cv',
}
export type ItemType = ItemTypeBase | ItemTypeCustom;


export enum ItemWrapperTypeCustom {
	BLOCKQUOTE = 'blockquote',
	HEADER_BOX_BIG = 'headerBoxBig',
	HEADER_BOX_FULLSCREEN = 'headerBoxFullscreen',
}
export type ItemWrapperType = ItemWrapperTypeBase | ItemWrapperTypeCustom;


export enum SectionWrapperTypeCustom {
	// BLOCKQUOTE = 'blockquote',
	// HEADER_BOX = 'headerBox',
}
export type SectionWrapperType = SectionWrapperTypeBase | SectionWrapperTypeCustom;

